module.exports = __webpack_public_path__ + "img/thumbnail_AsianWaterMonitor_j_erythristic.e76f2d3e.png";